import { Reveal } from "@components/ui";

const safetyPoints = [
  {
    title: "Rigorous Inspections",
    desc: "Comprehensive safety checks, testing, and certification across all installations.",
  },
  {
    title: "Dedicated HSE Team",
    desc: "Specialized team overseeing training, compliance, and emergency preparedness.",
  },
  {
    title: "Smart Technologies",
    desc: "Digital monitoring, automated billing, and mobile reporting for accuracy and efficiency.",
  },
  {
    title: "Sustainability Focus",
    desc: "Embracing innovation to improve environmental impact and user experience.",
  },
];

export function AboutSafetyCommitmentSection() {
  return (
    <section className="w-full py-16 md:py-20 lg:py-[100px] px-5 md:px-10 lg:px-[180px] bg-[#122d63] relative overflow-hidden">
      <div className="absolute top-0 right-0 w-[400px] h-[400px] bg-[#1a3a75] rounded-full blur-[120px] opacity-50 -translate-y-1/2 translate-x-1/3" />
      <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-[#f24d2b]/10 rounded-full blur-[100px] opacity-40 translate-y-1/2 -translate-x-1/3" />

      <div className="w-full max-w-[1368px] mx-auto relative z-10">
        <div className="flex flex-col lg:flex-row items-start gap-10 lg:gap-20">
          <div className="flex-1 flex flex-col gap-6">
            <Reveal direction="up">
              <span className="text-[13px] md:text-[14px] font-semibold tracking-[0.1em] uppercase text-[#f24d2b]">
                Our Promise
              </span>
            </Reveal>
            <Reveal direction="up">
              <h2 className="text-[28px] md:text-[36px] lg:text-[48px] font-semibold tracking-[-0.04em] text-white leading-[1.2]">
                Our Commitment to Safety & Innovation
              </h2>
            </Reveal>
            <Reveal direction="up">
              <p className="text-[16px] md:text-[19px] lg:text-[22px] tracking-[-0.02em] text-white/70 leading-[1.7]">
                At GASIS, safety is built into everything we do. We embrace
                smart technologies to improve accuracy, efficiency,
                sustainability, and user experience.
              </p>
            </Reveal>
          </div>

          <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {safetyPoints.map((point, i) => (
              <Reveal key={i} direction="up" delay={i * 60}>
                <div className="h-full rounded-2xl bg-white/[0.07] backdrop-blur-sm border border-white/10 p-6 flex flex-col gap-3 hover:bg-white/[0.12] transition-colors duration-300">
                  <div className="w-10 h-10 rounded-lg bg-[#f24d2b]/20 flex items-center justify-center">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M9 12l2 2 4-4" stroke="#f24d2b" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                      <circle cx="12" cy="12" r="10" stroke="#f24d2b" strokeWidth="1.5" />
                    </svg>
                  </div>
                  <h4 className="text-[17px] md:text-[19px] font-semibold tracking-[-0.03em] text-white">
                    {point.title}
                  </h4>
                  <p className="text-[14px] md:text-[16px] tracking-[-0.02em] text-white/60 leading-[1.6]">
                    {point.desc}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
